import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import type { ProductPlanFormModel } from "../../../model/type";

type QueryData = ProductPlanFormModel["QueryData"];
type ViewModel = ProductPlanFormModel["ViewModel"];

export type ProductPlanFormModelContextType = {
	viewModel: ViewModel;
	initInputModel: ProductPlanFormModel["InputModel"];
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;
	resetViewModel: () => void;

	queryData: QueryData;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
};

export const ProductPlanFormModelContext = createContext<ProductPlanFormModelContextType | null>(null);

export const useProductPlanFormModelContext = () => {
	const context = useContext(ProductPlanFormModelContext);

	if (!context) {
		throw new Error("useProductPlanFormModelContext must be used within a ProductPlanFormModelContext.Provider");
	}

	return context;
};
